export const defaultFinishButtonClickData = {
  event: "quote_journey",
  event_name: "quote_medical_details",
  step_name: "medical_details",
  medical_condition_added: null,
  trip_type: null,
  destination: null,
  destination_additions: null,
  trip_extra: null,
  cover_start_date: null,
  cover_end_date: null,
  travel_from: null,
  travel_group_type: null,
  medical_index: null,
};
